export {
  type ContentfulUpsellContentFields,
  useUpsellContent,
} from './useUpsellContent';
